import { render } from "./language-switcher.vue?vue&type=template&id=47e80bba"
import script from "./language-switcher.vue?vue&type=script&lang=js"
export * from "./language-switcher.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__